import { Component, Inject, Input, OnDestroy, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { Router } from '@angular/router';

import { TranslateService } from '@ngx-translate/core';

import { CustomerFacade, LoginFacade, ModalRef, NotificationFacade } from '@ridango/components';
import { AppStartupService } from '@ridango/core';
import { AccountDeleteConfirmationType } from '@ridango/core/lib/enums/features.enum';

import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
    selector: 'rwidget-customer-account-delete',
    templateUrl: './customer-account-delete.component.html'
})
export class CustomerAccountDeleteComponent implements OnInit, OnDestroy {
    private deleteConfirmationModal: ModalRef;
    private componentDestroyed$ = new Subject<void>();

    @ViewChild('modal') modalEl; // to focus on opened modal
    @ViewChild('actionSelector') actionSelectorEl; // to focus when modal is closed
    @ViewChild('deleteConfirmation', { read: TemplateRef, static: true }) deleteConfirmationRef: TemplateRef<any>;

    profile$: Observable<any> = this.customerFacade.profile$;
    actions$: Observable<string[]> = this.customerFacade.profileActions$;
    isDeletionSuccess$: Observable<boolean> = this.customerFacade.isDeletionSuccess$;

    @Input() deleteModalReference: ModalRef;

    accountDeleteConfirmationType = AccountDeleteConfirmationType;
    accountDeletionConfirmed = false;

    constructor(
        @Inject('ENV') public env: any,
        private customerFacade: CustomerFacade,
        private router: Router,
        private translate: TranslateService,
        private notification: NotificationFacade,
        private loginFacade: LoginFacade,
        public appStartupService: AppStartupService
    ) {}
    ngOnDestroy(): void {
        this.componentDestroyed$.next();
        this.componentDestroyed$.complete();
    }

    ngOnInit() {
        console.log(this.deleteModalReference);
        this.deleteConfirmationModal = this.deleteModalReference;
        this.isDeletionSuccess$
            .pipe(takeUntil(this.componentDestroyed$))
            .subscribe((success) => success && this.handleForget());
    }

    cancelDelete() {
        this.deleteConfirmationModal.close();
    }

    confirmDelete() {
        this.deleteConfirmationModal.close();
        this.customerFacade.sendCustomerProfileDeletionEmail();
    }

    toggleDeleteConfirmCheckbox() {
        this.accountDeletionConfirmed = !this.accountDeletionConfirmed;
    }

    confirmDeleteWithCheckbox() {
        if (this.accountDeletionConfirmed) {
            this.deleteConfirmationModal.close();
            this.customerFacade.deleteProfile();
        }
    }

    handleForget() {
        this.notification.success(this.translate.instant('LOCAL_CUSTOMER_FORGET_SUCCESS'), {
            title: this.translate.instant('LOCAL_CUSTOMER_FORGET_SUCCESS_TITLE'),
            showAfterRouteChange: true
        });

        this.loginFacade.logout();
        this.router.navigate([this.translate.currentLang, 'home']);
        this.customerFacade.clearCustomerProfile();
    }
}
